module.exports = __webpack_public_path__ + "static/media/process-flow-1-icon.b5099ac7.svg";